interface PreparationTaskDates {
  earliestStartDate?: string;
  deadline?: string;
}

export const getPreparationTaskDates = (
  mainTaskStartDate?: string,
  mainTaskEndDate?: string,
  maxTimeBeforeMainTaskDays?: number
): PreparationTaskDates => {
  const dates: PreparationTaskDates = {};

  if (mainTaskEndDate) {
    dates.deadline = mainTaskEndDate;
  }

  if (!mainTaskStartDate || maxTimeBeforeMainTaskDays === undefined) {
    return dates;
  }

  const preparationStartDate = new Date(mainTaskStartDate);
  if (isNaN(preparationStartDate.getTime())) {
    return dates;
  }

  preparationStartDate.setUTCDate(preparationStartDate.getUTCDate() - maxTimeBeforeMainTaskDays);

  return {
    ...dates,
    earliestStartDate: preparationStartDate.toISOString()
  };
};
